import { Button } from '@/components/Common';
import { Tabs } from '@/components/Ui';
import newTab from '@/assets/icons/new-tab.svg';
import QuestionForm from '@/components/Views/QuestionForm/QuestionForm';
import ListWithSubItems from '@/components/shared/ListWithSubItems';
import { Divider } from 'primereact/divider';
import { useEvaluation } from './Evaluation.hook';
import { useQuestionLogic } from '@/hooks/useQuestionLogic';
import { AlertModal } from '@/components/Layout/AlertModal/AlertModal';
import UploadQuizz from '../UploadQuizz/UploadQuizz';
import { useEvaluationStore } from '@/store/EvaluationStore/EvaluationStore';

export const EvaluationList = () => {
  const {
    exerciceTabs,
    handleEditTab,
    activeTabExercise,
    setActiveTabExercise,
    QuizzQuestionType,
    register,
    errors,
    handleSubmit,
    setValue,
    handleSelectedType,
    selectedType,
    response1Check,
    setResponse1Check,
    response2Check,
    setResponse2Check,
    response3Check,
    setResponse3Check,
    response4Check,
    setResponse4Check,
    selectedEvaluation,
    questions,
    handleSelectedQuizz,
    quizzMenuItems,
    handleCreateQuestion,
    handleUpdateQuestion,
    isEditingQuestion,
    handleConfirmExerciseAction,
    isCreateQuestionPending,
    loadingUpdateQuestion,
    isModalConfirmationExerciseOpen,
    setIsModalConfirmationExerciseOpen,
    handleDeleteExercise,
    loadingDeleteExercise,
    handleDeleteQuestion,
    isOpenEvaluationDeleteModal,
    setIsOpenEvaluationDeleteModal,
    isDeleteQuestionPending,
  } = useEvaluation();

  const { openQuizModal } = useQuestionLogic();
  const { setIsOpenModal } = useEvaluationStore();

  const onSubmit =
    selectedEvaluation && isEditingQuestion
      ? handleUpdateQuestion
      : handleCreateQuestion;

  return (
    <div>
      <UploadQuizz type="evaluation" />
      <div className="flex flex-col gap-4">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_auto] gap-4 items-start mb-10">
          <div className="overflow-x-auto w-full flex gap-2">
            <Tabs
              tabs={exerciceTabs}
              activeIndex={activeTabExercise}
              setActiveIndex={setActiveTabExercise}
              showAction={true}
              onDelete={(id) => handleConfirmExerciseAction?.(id)}
              onEdit={handleEditTab}
              type={'evaluation'}
            />
            <Button
              className="inline !bg-transparent !p-0 hover:!bg-transparent size-8 shrink-0"
              icon={<img src={newTab} alt="addModule" />}
              onClick={() => setIsOpenModal(true)}
            />
          </div>
          <div className="flex gap-2">
            <Button
              title="Upload"
              icon={<i className="pi pi-upload"></i>}
              iconPosition="right"
              className="!px-12"
              onClick={() => openQuizModal()}
            />
          </div>
        </div>

        <div className="relative grid grid-cols-[33%_auto] gap-4 overflow-x-hidden mb-10">
          <div className="w-full">
            <h1 className="font-bold text-2xl text-white mb-10 mt-6">
              {isEditingQuestion ? 'Modifier question' : 'Ajouter question'}
            </h1>
            <QuestionForm
              QuizzQuestionType={QuizzQuestionType}
              initialSelectedOptions={
                selectedEvaluation && isEditingQuestion
                  ? {
                      _id: selectedEvaluation.type,
                      name: selectedEvaluation.type,
                    }
                  : undefined
              }
              register={register}
              errors={errors}
              handleSubmit={handleSubmit}
              onSubmit={onSubmit}
              setValue={setValue}
              handleSelectedType={handleSelectedType}
              selectedType={selectedType}
              response1Check={response1Check}
              setResponse1Check={setResponse1Check}
              response2Check={response2Check}
              setResponse2Check={setResponse2Check}
              response3Check={response3Check}
              setResponse3Check={setResponse3Check}
              response4Check={response4Check}
              setResponse4Check={setResponse4Check}
              submitButtonText={
                isCreateQuestionPending || loadingUpdateQuestion
                  ? 'En cours...'
                  : isEditingQuestion
                    ? 'Modifier question'
                    : 'Ajouter question'
              }
            />
          </div>
          <Divider
            layout="vertical"
            className="absolute left-1/3 top-0 bg-dimGray w-[1px]"
          />
          <div className="w-full pl-20">
            <div className="ml-5 overflow-y-scroll overflow-x-auto h-[calc(100vh_-_110px)]">
              <ListWithSubItems
                items={questions || []}
                selectedItem={selectedEvaluation}
                onItemSelect={handleSelectedQuizz}
                menuItems={quizzMenuItems}
              />
            </div>
          </div>
        </div>
      </div>
      <AlertModal
        isOpen={isModalConfirmationExerciseOpen}
        onClose={() => setIsModalConfirmationExerciseOpen(false)}
        title={'Confirmation de suppression'}
        message={`Voulez-vous vraiment supprimer cet exercice ? Une fois supprimé, les questions associées seront également supprimées. Cette action est irréversible.`}
        buttonTitle={loadingDeleteExercise ? 'Suppression en cours...' : 'Oui'}
        buttonCancelTitle="Non"
        handleConfirm={handleDeleteExercise}
      />
      <AlertModal
        isOpen={isOpenEvaluationDeleteModal}
        onClose={() => setIsOpenEvaluationDeleteModal(false)}
        title={'Confirmation de suppression'}
        message={`Voulez-vous vraiment supprimer cette question ? Cette action est irréversible.`}
        buttonTitle={
          isDeleteQuestionPending ? 'Suppression en cours...' : 'Oui'
        }
        buttonCancelTitle="Non"
        handleConfirm={handleDeleteQuestion}
      />
    </div>
  );
};
